// removed by extract-text-webpack-plugin
module.exports = {"page":"EhPBvEcX5KnAJFEwejSYF","overlay":"_2CQYzSe6RRoZ_CXrK6BVdi","logo":"_3AoZAaNWQrimujvdFICQIk","logoWrap":"jPEyBHGuODVwzw4xG5_vU","notFoundContent":"_1Yv0ym8sqqyLbeuZW8RJlp","bigTitle":"_13vudYRzbwb4AyiE88mB8h","notFoundText":"_21LeYdOZxqV0HGtMs6PyL6"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/Pages/PageNotFound.css
 ** module id = 1752
 ** module chunks = 1
 **/